(function () {
  function fix(root) {
    (root || document).querySelectorAll('[data-nv] video').forEach(function (v) {
      if (v.dataset.loopfix) return;
      v.dataset.loopfix = '1';
      v.loop = true;
      v.muted = true;
      v.setAttribute('loop', '');
      v.setAttribute('autoplay', '');
      function again() {
        var item = v.closest('.nv__item');
        if (item && item.classList.contains('is-paused')) return;
        var r = v.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      v.addEventListener('ended', function () { v.currentTime = 0; again(); });
      v.addEventListener('pause', function () { setTimeout(again, 150); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();
